import { lsDecrypt, lsEncrypt } from "../utils/utils";

class TokenService {
  getToken() {
    let token = lsDecrypt("user");
    const user = JSON.parse(token);
    return user?.token;
  }

  setUser(user) {
    localStorage.setItem("user", JSON.stringify(user));
    lsEncrypt("user", JSON.stringify(user));
  }

  removeUser() {
    localStorage.removeItem("user");
  }
}

const tokenServiceInstance = new TokenService();
export default tokenServiceInstance;
